import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Proj1 from './Components/proj1';
import TourPackageDetail from './Components/TourPackageDetail';
import UserDashboard from './Pages/UserDashboard';
import AdminPackageUI from './Pages/AdminDashboard';
import AllPackage from './Pages/AllPackage';
import EditPackage from './Pages/EditPackage';
import ViewMorePage from './Pages/ViewMorePage';
import Footer1 from './Components/Footer1';
import ProtectedRoute from './utils/PrivateRoute';
import Login from './Components/Login';
import AdminLogin from './Pages/AdminLogin';
import AdminReviewManagement from './Pages/AdminReviewManagement';
import { ToastContainer } from 'react-toastify';
import BannerAdmin from './Pages/BannerAdmin';
import AllUser from './Pages/AllUser';
import CreateBookingPage from './Pages/CreateBookingPage';
import Header from './Components/Header';
import TermsConditions from './Pages/TermAndConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import AboutUs from './Pages/AboutUs';
import CreateFakeReview from './Pages/FakeReviews';
import AdminContactManagement from './Pages/AdminContactManagement';

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <Proj1 />
            <Footer1 />
          </>
        } />
        <Route path="/package-detail/:id" element={
          <>
            <TourPackageDetail />
            <Footer1 />
          </>
        } />
        <Route path="/type-package/:tourType" element={
          <>
            <ViewMorePage />
            <Footer1 />
          </>
        } />
        <Route path="/terms-and-conditions" element={
          <>
            <TermsConditions />
            <Footer1 />
          </>
        } />

        <Route path="/privacy-policy" element={
          <>
            <PrivacyPolicy />
            <Footer1 />
          </>
        } />
        <Route path="/about-us" element={
          <>
            <AboutUs />
            <Footer1 />
          </>
        } />

        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute roles={['user', 'admin']} />}>
          <Route path="/user/profile" element={
            <>
              <UserDashboard />
            </>

          } />
        </Route>
        <Route element={<ProtectedRoute roles={['admin']} />}>
          <Route path="/admin-dashboard" element={<AdminPackageUI />} />
          <Route path="/all-package" element={<AllPackage />} />
          <Route path="/all-banner" element={<BannerAdmin />} />
          <Route path="/all-user" element={<AllUser />} />
          <Route path="/contact-management" element={<AdminContactManagement />} />
          <Route path="/create-booking" element={<CreateBookingPage />} />
          <Route path="/create-reviews" element={<CreateFakeReview />} />
          <Route path="/review-management" element={<AdminReviewManagement />} />
          <Route path="/edit-package/:id" element={<EditPackage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;